import script from "./FeedViewPostPage.vue?vue&type=script&setup=true&lang=ts"
export * from "./FeedViewPostPage.vue?vue&type=script&setup=true&lang=ts"

import "./FeedViewPostPage.vue?vue&type=style&index=0&id=d8d9be18&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-d8d9be18"]])

export default __exports__